var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5825 26.7879C15.9381 28.4711 18.6241 28.0413 19.379 26.0204L27.6371 3.91401C28.4687 1.68791 26.2822 -0.478857 24.043 0.352392L1.81478 8.60423C-0.218153 9.35893 -0.644312 12.0283 1.05383 13.3707L5.35903 16.774C6.02828 17.303 6.97442 17.3108 7.65237 16.7928L18.0723 8.83119C18.3706 8.60326 18.7929 8.63049 19.059 8.89484C19.3251 9.15918 19.3525 9.5786 19.1231 9.87491L11.1101 20.222C10.5875 20.8968 10.5965 21.8389 11.1319 22.5036L14.5825 26.7879Z",
    fill: "#A64EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBh);
export default __webpack_public_path__ + "static/media/LogoBH.b0eb23b848f6b7067a8e7055071719d7.svg";
export { ForwardRef as ReactComponent };